import yup from '../../../config/yup';

export const ethosV2ReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('ethosV2Reader'),
  delayedRead: yup.boolean(),
  connectionKey: yup.string(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    apiKey: yup.string(),
    rootUrl: yup.string(),
    maxApiRequestRetries: yup.number().min(1, 'Max API request retries must be at least 1'),
    path: yup.string().required('Path is required'),
    httpMethod: yup
      .string()
      .oneOf(['GET', 'POST', 'PUT', 'DELETE'])
      .required('HTTP Method is required'),
    headers: yup.string().required('Headers are required'),
    query: yup.string(),
  }),
});
